export const aciXClose = {
    iconName: 'x-close',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M3.277 3.035a.535.535 0 00-.242.242.54.54 0 00.004.392c.03.068.914.962 4.16 4.209L11.32 12l-4.121 4.122c-3.246 3.247-4.13 4.14-4.16 4.209a.556.556 0 00-.01.378c.039.094.152.211.248.255a.54.54 0 00.392-.003c.068-.03.962-.914 4.209-4.16L12 12.68l4.122 4.121c3.247 3.246 4.14 4.13 4.209 4.16a.54.54 0 00.392.003.577.577 0 00.248-.255.556.556 0 00-.01-.378c-.03-.068-.914-.962-4.16-4.209L12.68 12l4.121-4.122c3.246-3.247 4.13-4.14 4.16-4.209a.54.54 0 00.004-.392.577.577 0 00-.256-.248.556.556 0 00-.378.01c-.068.03-.962.914-4.209 4.16L12 11.32 7.878 7.199c-3.247-3.246-4.14-4.13-4.209-4.16a.545.545 0 00-.392-.004z',
                fill: 'currentColor',
            },
        },
    },
};
